import type { OperatorDescriptions_OperatorDescription } from "@smartsuite/automation-engine-api";
import type { UpdateValueType } from "./components/UpdateValueOption";
import type { MathOptions } from "./components/MathOption";
import { OperatorDescriptionKinds } from "./constanst";

export const isAvailableOperator = (
  operator: string,
  operatorDescriptions: OperatorDescriptions_OperatorDescription[] | undefined,
): boolean => {
  if (operatorDescriptions === undefined) {
    return false;
  }
  return operatorDescriptions.some((operatorDescription) => {
    return operatorDescription.operator.oneofKind === operator;
  });
};

export const isMathOption = (
  selected: UpdateValueType | MathOptions,
): selected is MathOptions =>
  [
    OperatorDescriptionKinds.MATH_ADD,
    OperatorDescriptionKinds.MATH_SUBTRACT,
    OperatorDescriptionKinds.MATH_DIVIDE,
    OperatorDescriptionKinds.MATH_MULTIPLY,
  ].includes(selected);
